import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const appPermissionsTransform = createTransform(
    (inboundState, key) => {
        if (key === 'appPermissions') {
            const { accessToken, ...rest } = inboundState;
            return rest;
        }
        return inboundState;
    },
    (outboundState, key) => {
        if (key === 'appPermissions') {
            return { ...outboundState, accessToken: null };
        }
        return outboundState;
    }
);

const persistConfig = {
    key: 'root',
    keyPrefix: 'knights-',
    storage,
    whitelist: ['appPermissions', 'appSetting', 'settings'],
    blacklist: ['customer', 'viewSettings'],
    transforms: [appPermissionsTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

let appliedMiddleware = applyMiddleware(thunk);

if (process.env.NODE_ENV === `development`) {
    const { createLogger } = require(`redux-logger`);
    appliedMiddleware = applyMiddleware(thunk, createLogger());
}

const store = createStore(
    persistedReducer,
    compose(
        appliedMiddleware,
        window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
            return f;
        }
    )
);

export const persistor = persistStore(store);
export default store;
